import * as msal from "@azure/msal-browser";
import React, { Component } from "react";
import { Trans } from "react-i18next";

import TranslationMapper from "i18n/mapper";
import LanguageProvider from "providers/languageProvider";

import NoAccess from "../../assets/img/no-access.svg";
import CleaningUserAuthenticator from "../../authenticators/cleaningUserAuthenticator";
import MainHeader from "../header/mainHeader";

interface ErrorViewProps {
  user: msal.AccountInfo | null;
}

class ErrorView extends Component<ErrorViewProps> {
  private readonly userAuthenticator: CleaningUserAuthenticator;

  private constructor(props: ErrorViewProps) {
    super(props);

    this.userAuthenticator = new CleaningUserAuthenticator();
    this.logoutUser = this.logoutUser.bind(this);
  }

  private logoutUser(): void {
    this.userAuthenticator.signOut();
  }

  public render(): React.ReactNode {
    return (
      <div className="min-vh-100">
        <MainHeader />
        <main className="error-view__main d-flex justify-content-center align-items-center container-fluid text-center flex-column">
          <img alt="no access" height={200} width={200} src={NoAccess} />
          <h1>{LanguageProvider.t("errors.no_access")}</h1>
          <p>
            {this.props.user ? (
              <Trans
                i18nKey={TranslationMapper.errors.no_access_user}
                values={{ username: this.props.user?.username }}
              />
            ) : (
              LanguageProvider.t(TranslationMapper.errors.no_access_no_user)
            )}
          </p>
          <button onClick={this.logoutUser} className="btn btn-primary mt-3">
            {LanguageProvider.t(TranslationMapper.buttons.logout)}
          </button>
        </main>
      </div>
    );
  }
}

export default ErrorView;
